'use strict';
import axios from 'axios';
import getHeader from '../config/header';

const API_URL = process.env.VUE_APP_API_URL || "http://localhost:3001/api";

const Eras = {

    async getAll() {
		try {
            let response = await axios.get(API_URL + '/eras', await getHeader());

			return response.data;

		} catch(error) {
            return false;
		}
	},

	async createNew(name, description = null) {
		try {
			if (!name) {
				return { error: 'Era name is required.' };
			}

            let response = await axios.post(API_URL + '/era', {
				"name": name,
				"description": description,
			}, await getHeader());
		
			if (response.data) {
				return true;
			}

		} catch(error) {
            return false;
		}
	},

	async update(eraID, name, description = null) {
		try {
			if (!eraID || !name) {
				return { error: 'Era name and ID are required.' };
			}

            let response = await axios.patch(API_URL + '/era/' + eraID, {
				"name": name,
				"description": !description ? null : description,
			}, await getHeader());
		
			if (response.data) {
				return true;
			}

		} catch(error) {
            return false;
		}
	},

	async delete(eraID) {
		try {
			if (!eraID) {
				return { error: 'Era ID is required.' };
			}

            let response = await axios.delete(API_URL + '/era/' + eraID, await getHeader());
		
			if (response.data) {
				return true;
			}

		} catch(error) {
            return false;
		}
	}
    
}

export default Eras;
